import * as signalR from "@microsoft/signalr";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { PayrollRunning } from "../utils/redux/Finance/PayrollSlice/PayrollSlice";

const Signalr = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl("https://bpmapi.nlpcpfa.com/FinanceService/notifyEndpoint")
      .build();
    connection
      .start()
      .then(() => {
        toast.success("Connected");
      })
      .catch((error) => {
        toast.error("Connection error:", error);
      });

    connection.on(
      "PayrollGenerationMessage",
      (user, batchId, status, month, batchName) => {
        toast.success(
          `Payroll generation sequence completed for user ${user} with batch ID ${batchId}  and status of ${status} with batch name ${batchName}`
        );
        if (status) {
          dispatch(PayrollRunning(false));
        }
      }
    );
    return () => {
      connection.stop();
    };
  }, []);
  return <>{children}</>;
};

export default Signalr;
